import React, { Component} from 'react'
import {NavLink, Redirect} from 'react-router-dom'
import imgT1 from '../images/T1.gif'

//import Sweeper from './Games/Sweeper/Sweeper'
class GamesPage extends Component {
 
  constructor(props) {
    super(props);


    this.state = {
      usr: props.data.usr,      
      logo: props.data.logo
    }
     
    console.log('props', props.data)
    
  }


   
    render() { 
                           
  
      return (!this.state.usr)?(<Redirect to="/"/>):(<div className='mypage fluid-container p-3'>
        <h2>Games</h2>
                <div className="row">
                
                  <div className="col-12 col-md-4">              
                  <NavLink to="/games/sweeper">
                        <h3>Sweeper</h3>
                      <img alt="sweeper" className="gameport img-thumbnail" src="https://i.giphy.com/media/oe33xf3B50fsc/giphy.webp"/> 
                    </NavLink>
                  </div>
                  
                  <div className="col-12 col-md-4">
                  <NavLink to="/games/voidcheddar3rddoz">
                         <h3>(Coming Soon) Void Cheddar's Dirty Third Dozen</h3>
                         <img alt="funpics" className="gameport img-thumbnail" src={imgT1} />
                         </NavLink>
                  </div>              
                  <div className="col-12 col-md-4">
                         <h3>Mysteries of the future...</h3>
                         <img alt="mystery" className="gameport img-thumbnail" src={this.state.logo} />
                  </div>
                </div>
              </div>);
                          
              
  
      
    }  

  
}




export default GamesPage; 


// WEBPACK FOOTER //
// ./src/components/GamesPage.js